module.exports = __webpack_public_path__ + "img/r2.010fa11a.jpg";